import { UseFormReturn } from "react-hook-form";
import { Dialog } from "@themes/pollinator/ui/Dialog";
import { Form } from "@themes/pollinator/ui/Form";
import { FormField } from "@themes/pollinator/ui/FormField";

export type Props = {
  isOpen: boolean;
  isSubmitSuccessful: boolean;
  isSubmitting: boolean;
  isValid: boolean;
  form: UseFormReturn<{ code: string }>;
  onSubmit: () => void;
  onClose: () => void;
  onSecondaryClick: () => void;
};

/**
 * Dialog for entering an organization invite code.
 * Pure presentational component - receives all state and callbacks via props.
 */
export function OrgCodeDialog({
  isOpen,
  isSubmitSuccessful,
  isSubmitting,
  isValid,
  form,
  onSubmit,
  onClose,
  onSecondaryClick,
}: Props) {
  return (
    <Dialog
      isOpen={isOpen}
      isWithActions={!isSubmitSuccessful}
      onClose={onClose}
      title={isSubmitSuccessful ? "Code Found" : "Join Pollinator"}
      description={
        isSubmitSuccessful
          ? "Redirecting..."
          : "The inaugural Pollinator Program launches in October of 2025. Join a peer circle for five weeks of focused creative momentum."
      }
      primaryButtonText="Join"
      onPrimaryClick={onSubmit}
      onSecondaryClick={onSecondaryClick}
      secondaryButtonText="I don't have a code"
      primaryButtonProps={{
        disabled: isSubmitting,
        visuallyDisabled: !isSubmitting && !isValid,
        type: "submit",
      }}
      secondaryButtonProps={{
        disabled: isSubmitting,
      }}
    >
      {!isSubmitSuccessful && (
        <Form form={form} className="py-8" errorContainerClassName="p-0 mt-8">
          <FormField
            name="code"
            label="Invite Code"
            component="Input"
            placeholder="Enter your code"
            required
            transformOnChange={(val: string) =>
              val.toUpperCase().replace(/\s+/g, "")
            }
          />
        </Form>
      )}
    </Dialog>
  );
}

export default OrgCodeDialog;
